import React, { useState, useEffect } from "react";

interface ScrollArrowProps {
  className?: string;
  style?: React.CSSProperties;
}

export default function ScrollArrow({
  className = "",
  style,
}: ScrollArrowProps) {
  const [isVisible, setIsVisible] = useState(false);
  const [arrowSize, setArrowSize] = useState({ width: 68, height: 75 });

  useEffect(() => {
    // Fade-in after 0.5s
    const timer = setTimeout(() => setIsVisible(true), 500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Responsive sizing (like Logo)
    const updateSize = () => {
      if (window.innerWidth < 768) {
        // Mobile: ~60% of desktop size (like Logo: 67.5/105 ≈ 64%)
        setArrowSize({ width: 43, height: 48 });
      } else {
        setArrowSize({ width: 68, height: 75 });
      }
    };

    updateSize();
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  return (
    <svg
      className={`scroll-arrow ${className}`}
      width={arrowSize.width}
      height={arrowSize.height}
      viewBox="0 0 177.38 194.19"
      style={{
        ...style,
        opacity: isVisible ? 1 : 0,
        filter: `blur(${isVisible ? 0 : 6}px)`,
        transform: `translateY(${isVisible ? 0 : -10}px)`,
        transition:
          "opacity 0.8s ease-out, filter 0.8s ease-out, transform 0.8s ease-out",
      }}
    >
      <line
        stroke="#fff"
        strokeWidth="30"
        strokeMiterlimit="10"
        fill="none"
        x1="88.69"
        x2="88.69"
        y2="166.1"
      />
      <polyline
        stroke="#fff"
        strokeWidth="30"
        strokeMiterlimit="10"
        fill="none"
        points="12.73 91.62 89.84 168.73 164.65 93.92"
      />
    </svg>
  );
}
